import React from 'react';
import { Link } from 'react-router-dom';

import './Navbar.css';

// navigation header
export default class Navbar extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      click: false,
      button: true
    };
  }

  handleClick = () => {
    this.setState({ click: !this.state.click });
  };

  closeMobileMenu = () => {
    this.setState({ click: false });
  };

  showButton = () => {
    if (window.innerWidth <= 960) {
      this.setState({ button: false });
    } else {
      this.setState({ button: true });
    }
  };

  componentDidMount() {
    this.showButton();
    window.addEventListener('resize', this.showButton);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.showButton);
  }

  render() {
    return (
      <nav className='navbar' aria-label='Main navigation'>
        <div className='navbar-container'>

          <Link to='/' className='navbar-logo' onClick={this.closeMobileMenu}>
            <img
              width="55"
              height="55"
              src='asset/images/stamp_logo.jpg'
              alt='Boyang Zhou - Home'
            />
          </Link>

          <button
            className='menu-icon'
            onClick={this.handleClick}
            aria-label={this.state.click ? 'Close menu' : 'Open menu'}
            aria-expanded={this.state.click}
          >
            <i className={this.state.click ? 'fa-solid fa-xmark' : 'fa-solid fa-bars'} aria-hidden="true" />
          </button>

          <ul
            className={this.state.click ? 'nav-menu active' : 'nav-menu'}
            onClick={this.closeMobileMenu}
          >

            <li className='nav-item'>
              <Link
                to='/'
                className='nav-links'
                onClick={() => {
                  this.closeMobileMenu();
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
              >
                Home
              </Link>
            </li>

            <li className='nav-item'>
              <a
                href='#/'
                className='nav-links'
                onClick={(e) => {
                  e.preventDefault();
                  this.closeMobileMenu();
                  // Navigate to home first, then scroll to research
                  window.location.hash = '#/';
                  setTimeout(() => {
                    const el = document.getElementById('research');
                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                  }, 100);
                }}
              >
                Research
              </a>
            </li>

            {/* <li className='nav-item'>
              <Link
                to='/projects'
                className='nav-links'
                onClick={this.closeMobileMenu}
              >
                Projects
              </Link>
            </li>

            <li className='nav-item'>
              <Link
                to='/blog'
                className='nav-links'
                onClick={this.closeMobileMenu}
              >
                Blogs
              </Link>
            </li> */}

            <li className='nav-item'>
              <Link
                to='/resume'
                className='nav-links'
                onClick={this.closeMobileMenu}
              >
                CV
              </Link>
            </li>
          </ul>

        </div>
      </nav>
    );
  }
}
